import React, { useRef } from 'react';
import { RiCheckLine } from 'react-icons/ri';
import { cn } from '../Utlils';

const MyStepper = ({
  stepsConfig,
  currentStep,
  isComplete,
  position = 'horizontal',
}) => {
  const stepRef = useRef([]);

  if (!stepsConfig?.length) return null;

  const ActiveComponentNode = stepsConfig?.[currentStep - 1]?.Component;
// console.log({
//   stepsConfig,
//   currentStep,
//   isComplete,
//   position,
// });


  return (
    <div className={cn(position !== 'horizontal' && 'flex')}>
      {/* Step Header */}
      <div
        className={cn(
          'relative',
          position === 'horizontal'
            ? 'flex justify-center items-start'
            : 'flex flex-col  sticky top-[160px] h-[15%] pt-2  ',
        )}
      >
        {stepsConfig?.map((step, index) => (
          <div
            key={index}
            ref={(el) => (stepRef.current[index] = el)}
            className={cn(
              position === 'horizontal'
                ? 'flex gap-4 flex-col'
                : 'flex gap-6 justify-start',
              index === stepsConfig.length - 1 ? 'w-auto' : 'w-full',
              currentStep > index + 1 || isComplete ? 'complete' : '',
            )}
          >
            <div
              className={cn(
                '',
                position === 'horizontal'
                  ? 'flex items-center'
                  : 'flex flex-col',
              )}
            >
              <div
                className={`w-[20px] h-[20px] rounded-full bg-gray-100 flex justify-center items-center ${
                  currentStep === index + 1
                    ? 'border border-blue-600'
                    : 'border border-gray-200'
                } ${
                  currentStep > index + 1 || isComplete
                    ? 'bg-blue-600 border-none'
                    : ''
                }`}
              >
                {currentStep === index + 1 && !isComplete && (
                  <span className="w-[10px] h-[10px] rounded-full bg-blue-600"></span>
                )}
                {(currentStep > index + 1 || isComplete) && (
                  <span>
                    <RiCheckLine size={12} color="#fff" />
                  </span>
                )}
              </div>
              {index !== stepsConfig.length - 1 && (
                <div
                  className={cn(
                    'mx-auto rounded-lg bg-gray-200',
                    position === 'horizontal'
                      ? 'w-[80%] h-1'
                      : 'h-[80px] w-1 my-2',
                  )}
                >
                  <p
                    className={cn(
                      'h-full rounded-lg',
                      currentStep > index + 1 ? 'bg-blue-600' : '',
                    )}
                  ></p>
                </div>
              )}
            </div>

            <div
              className={cn(
                'whitespace-nowrap',
                position === 'vertical' || step?.helperName ? '-mt-1' : '',
              )}
            >
              <span className="text-gray-400 text-text-xs">
                {step?.helperName}
              </span>
              <p>{step?.name}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Step Body */}
      <div className={cn("w-full ",position==="horizontal"?"pt-8":"pt-0",)}>{ActiveComponentNode}</div>
    </div>
  );
};

export default MyStepper;
